module.exports = __webpack_public_path__ + "static/back1-5276adbb5e7af8bc7fe0bafca3d2ff82.png";